import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";
import type { ISiteSlim } from "App/Modules/Models";

import { TextField, InputAdornment, Chip } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { faSearch } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./_sites-link-filter.scss";

type SiteState = {
    label: string;
    id: string;
    value: string;
};

type OwnProps = {
    active: boolean;
    sites: ISiteSlim[];
    onChange: (searchFilter: string, siteStates: SiteState[]) => void;
};

export const SitesLinkFilter = (props: OwnProps) => {
    const [searchFilter, setSearchFilter] = useState("");
    const [stateFilter, setStateFilters] = useState<SiteState[]>([]);
    const { t } = useTranslation();

    const onSearchFilterChange = useAsyncDebounce(() => {
        props.onChange(searchFilter, stateFilter);
    }, 200);

    const findStateColor = (siteState) => {
        if (siteState === "Normal") {
            return "#5abe27";
        }
        if (siteState === "Maintenance") {
            return "#1a84cb";
        }
        if (siteState === "Not started") {
            return "#e89f30";
        }
        return "";
    };
    const filterState = (sites: any[]) => {
        const seen = {};
        return sites.filter((site) => {
            const state = site.siteState;
            const stateIs = seen.hasOwnProperty(state) ? false : (seen[state] = true);
            return stateIs;
        });
    };

    const availableSiteStates = filterState(props.sites);

    return (
        <React.Fragment>
            {props.active ? (
                <div className="sites-link-filter sites-link-filter--active">
                    <div className="sites-link-filter__search-input">
                        <TextField
                            variant="outlined"
                            size="small"
                            value={searchFilter}
                            onChange={(e) => {
                                setSearchFilter(e.target.value);
                                onSearchFilterChange();
                            }}
                            placeholder={t("Gui.Common.FilterPlaceholder")}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FontAwesomeIcon icon={faSearch} transform="shrink-2" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        {availableSiteStates ? (
                            <Autocomplete
                                multiple
                                options={availableSiteStates.map((site) => {
                                    return {
                                        label: t(`Enums.SiteState.Enum${site.siteState}`),
                                        value: site.siteState,
                                        id: site.id,
                                    } as SiteState;
                                })}
                                getOptionLabel={(option) => option.label}
                                value={stateFilter}
                                size="small"
                                onChange={(event: any, value: SiteState[]) => {
                                    setStateFilters(value);
                                    onSearchFilterChange();
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder={t("Gui.Manage.SiteEventsTable.Header.Status")}
                                    />
                                )}
                                renderTags={(value: SiteState[], getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            {...getTagProps({ index })}
                                            className="state-tag"
                                            style={{
                                                backgroundColor: findStateColor(option.label),
                                                color: "#fff",
                                                fontSize: "12px",
                                                fontWeight: 500,
                                                letterSpacing: "1px",
                                            }}
                                            key={option.id}
                                            size="small"
                                            label={option.label}
                                        />
                                    ))
                                }
                            />
                        ) : null}
                    </div>
                    <span className="sites-link-filter__caption">{t("Gui.Common.AlarmCentralSites.Search")}</span>
                </div>
            ) : null}
        </React.Fragment>
    );
};
